// extracted by mini-css-extract-plugin
export default {"BaseCell":"sub-issues-progress-renderer-module__BaseCell--IKedv","ButtonBase":"sub-issues-progress-renderer-module__ButtonBase--tyRvx"};